<label
  for="name"
  class="checkbox-container {{ containerClasses() }}"
  (click)="onClick()"
>
  <input
    [tabIndex]="0"
    class="check"
    type="checkbox"
    [name]="name()"
    [checked]="checked()"
    [disabled]="disabled()"
    (keydown.enter)="onClick()"
  />
  <span class="checkmark mr-2" [class.invalid]="invalid()"></span>
  @if (label()) {
    {{ label() }}
  }
</label>
